import { Box, CircularProgress, Container, Divider, Stack, Typography } from "@mui/material";

interface UpgradeAgentProps {
  pageWidth?: number;
  loading?: boolean;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  title: string;
  subtitle?: React.ReactNode;
}

const PageLayout = ({ pageWidth = 745, loading, children, footer, title, subtitle }: UpgradeAgentProps) => {
  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          height: "95vh",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container sx={{ pt: 4 }}>
      <Box
        sx={{
          mt: 6,
          mb: 4,
          mx: "auto",
          maxWidth: pageWidth,
        }}
      >
        <Stack spacing={4}>
          <Stack spacing={2}>
            <Typography variant="h1">{title}</Typography>
            {subtitle}
          </Stack>

          {children}
        </Stack>
      </Box>

      <Box
        sx={{
          bgcolor: "background.paper",
          position: "fixed",
          bottom: 0,
          width: "100%",
          left: 0,
          zIndex: 20,
        }}
      >
        <Divider sx={{ gridColumn: "1/13" }} />
        <Box
          sx={{
            mx: "auto",
            maxWidth: pageWidth,
            display: "flex",
            py: 1,
            margin: "auto",
            justifyContent: "flex-end",
          }}
        >
          {footer}
        </Box>
      </Box>
    </Container>
  );
};

export default PageLayout;
